import Bookmark from "assets/bookmark.png";
import Bookmarked from "assets/bookmarked.png";
import { updateBookmarkedPlan } from "components/features/AboveProperty/AboveProperty.slice";
import { updateBookmarkedInncodesAsync } from "components/features/dashboard/Dashboard.slice";
import {
  bookmarkPlan,
  fetchBookmarkPlansIdAsync,
  removeBookmarkPlan,
  removeBookmarkedPlan
} from "components/features/library/Bookmark/Bookmark.slice";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { nestedTernaryCheckerCond2 } from "utils/CommonChecker";
import {
  abovePropertyViewTypePlan,
  abovePropertyViewTypeProperty,
  abovePropertyViewTypeTemplate,
  accessTypes
} from "utils/CommonConstants";
import Button from "./Button";
import ToolTip from "./Tooltip";

interface Props {
  isBookmarked: boolean;
  cmsId?: number;
  aboveUserPayload?: any;
  innCodeForPayload?: string;
  onClickFunction?: any;
}

export default function BookmarkPlan(props: Props) {
  const translate = useTranslate();
  const { isBookmarked, cmsId, aboveUserPayload, innCodeForPayload = "", onClickFunction } = props;
  const dispatch = useAppDispatch();
  const [isbookmark, setIsBookmarked] = useState(isBookmarked);
  const [isDisabled, setIsDisabled] = useState(false);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const { bookmarkedIdList, bookmarkedTemplate } = useAppSelector((state) => state.aboveProperty);
  const { bookmarkedProperties }: any = useAppSelector((state) => state.aboveProperty);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);

  useEffect(() => {
    setIsBookmarked(isBookmarked);
  }, [cmsId, isBookmarked]);

  async function handleBookmarking() {
    setIsDisabled(true);
    if (isbookmark) {
      setIsBookmarked(!isbookmark);
      await dispatch(removeBookmarkPlan({ cmsId, innCode: innCodeForPayload || innCode }));
      dispatch(removeBookmarkedPlan(cmsId));
      onClickFunction && onClickFunction();
    } else {
      setIsBookmarked(!isbookmark);
      await dispatch(bookmarkPlan({ cmsId, innCode: innCodeForPayload || innCode }));
    }
    await dispatch(fetchBookmarkPlansIdAsync());
    setIsDisabled(false);
  }

  const handlePlanBookmarkForAboveUser = async () => {
    setIsDisabled(true);
    if (aboveUserPayload?.viewType === abovePropertyViewTypePlan) {
      if (isbookmark) {
        setIsBookmarked(!isbookmark);
        await dispatch(
          updateBookmarkedPlan({
            viewType: aboveUserPayload?.viewType,
            payload: {
              bookmarkPlans: bookmarkedIdList?.filter((item: any) => item.cmsId !== cmsId)
            }
          })
        );
      } else {
        setIsBookmarked(!isbookmark);
        await dispatch(
          updateBookmarkedPlan({
            viewType: aboveUserPayload?.viewType,
            payload: {
              bookmarkPlans: [
                ...bookmarkedIdList,
                {
                  cmsId: cmsId
                }
              ]
            }
          })
        );
      }
    } else if (aboveUserPayload?.viewType === abovePropertyViewTypeTemplate) {
      if (isbookmark) {
        setIsBookmarked(!isbookmark);
        await dispatch(
          updateBookmarkedPlan({
            viewType: aboveUserPayload?.viewType,
            payload: {
              bookmarkTemplatePlans: bookmarkedTemplate?.filter((item: any) => item.templatePlanId !== cmsId)
            }
          })
        );
      } else {
        setIsBookmarked(!isbookmark);
        await dispatch(
          updateBookmarkedPlan({
            viewType: aboveUserPayload?.viewType,
            payload: {
              bookmarkTemplatePlans: [
                ...bookmarkedTemplate,
                {
                  templatePlanId: cmsId
                }
              ]
            }
          })
        );
      }
    } else {
      const bookmarkedPropertiesList = isbookmark
        ? bookmarkedProperties?.filter((item: any) => item?.innCode !== aboveUserPayload?.inncode)
        : [
            ...bookmarkedProperties,
            {
              innCode: aboveUserPayload?.inncode
            }
          ];

      setIsBookmarked(!isbookmark);
      await dispatch(
        updateBookmarkedInncodesAsync({
          bookmarks: bookmarkedPropertiesList
        })
      );
      onClickFunction && onClickFunction();
    }
    setIsDisabled(false);
  };

  return (
    <>
      <ToolTip
        title={nestedTernaryCheckerCond2(
          isbookmark,
          aboveUserPayload?.viewType === abovePropertyViewTypeProperty,
          translate("dashboard.removeBookmark"),
          translate("dashboard.bookmarkThisHotel"),
          translate("dashboard.bookmarkThisPlan")
        )}
      >
        <Button
          accessType={isAdmin && !isImpersonated ? accessTypes.view : accessTypes.update}
          iconButton
          height="23"
          disabled={isDisabled}
          sx={{ p: 0, marginX: "-8px", "&.MuiIconButton-root:active": { border: "none" } }}
          icon={isbookmark ? Bookmarked : Bookmark}
          onClick={aboveUserPayload?.isAboveUsertype ? handlePlanBookmarkForAboveUser : handleBookmarking}
        />
      </ToolTip>
    </>
  );
}
